import { useState } from "react";
import { AllieIconButton } from "../../../components/Buttons/IconButton";
import { AllieDownloadIcon, AllieFilterIcon, AllieSortIcon } from "../../../styling/icons";
import { AllieReportDownloader, AllieReportDownloaderQuery } from "../ReportDownloader";
import { StyledActionButtonBarContainer } from "./ActionButtonBar.styles";

export interface ActionButtonBarProps {
  downloadQuery?: Function;
  downloadTitle?: string;
  initFilterBarOpen?: boolean;
  toggleFilterBar?: (show: boolean) => void;
}

export const AllieActionButtonBar = ({
  downloadQuery,
  downloadTitle,
  initFilterBarOpen,
  toggleFilterBar,
}: ActionButtonBarProps) => {
  const [showFilterBar, setShowFilterBar] = useState(Boolean(initFilterBarOpen));

  return (
    <StyledActionButtonBarContainer>
      {/* <AllieIconButton corner='rounded-edges' allieColor='light' allieSize='small'>
        <AllieSortIcon />
      </AllieIconButton> */}
      {
        toggleFilterBar && (
          <AllieIconButton
            corner='rounded-edges'
            allieColor='light'
            allieSize='small'
            onClick={() => {
              toggleFilterBar(!showFilterBar);
              setShowFilterBar(!showFilterBar);
            }}
          >
            <AllieFilterIcon allieColor={showFilterBar ? undefined : 'neutral-60'} />
          </AllieIconButton>
        )
      }
      {
        downloadTitle && downloadTitle && (
          <AllieReportDownloader
            title={downloadTitle}
            query={downloadQuery as AllieReportDownloaderQuery}
            render={({ onClick }) => (
              <AllieIconButton
                corner='rounded-edges'
                allieColor='light'
                allieSize='small'
                onClick={onClick}
              >
                <AllieDownloadIcon allieColor="neutral-60" />
              </AllieIconButton>
            )}
          />
        ) 
      }
    </StyledActionButtonBarContainer>
  )
};
